// extracted by mini-css-extract-plugin
var _1 = "SettingsSection-module__header--o29oi";
var _2 = "SettingsSection-module__section--JGxVR";
export { _1 as "header", _2 as "section" }
